<template>
  <div ref="events_page" class="w-full">
    <div id="teacher-calendar-container" class="vx-row mx-auto">
      <div class="vx-col xl:w-1/3 lg:w-1/3 md:w-full sm:w-full xs:w-full">
        <h3 style="font-size:22pt" class="text__school-font-color text-center mb-3">SELECT A DAY</h3>
        <datepicker ref="fromPicker" v-model="pickerDate" :inline="true" :format="format" :highlighted="highlightedFn"></datepicker>
      </div>
      <div class="vx-col xl:w-2/3 lg:w-2/3 md:w-full sm:w-full xs:w-full">
        <div class="vx-row">
          <div class="vx-col">
            <div style="text-align: left;">
              <p class="text__school-font-color" style="font-size:22pt;font-variant: all-petite-caps;line-height: 1;"><strong>{{ currentDay == displayDate.split(" ")[0] ? 'Today' : displayDate.split(" ")[0] }}</strong></p>
              <p class="text__school-font-color" style="font-size:80pt;line-height: 85px;"><strong>{{ displayDate.split(" ")[1] }}</strong></p>
              <p class="text__school-font-color" style="font-size:30pt;font-variant: all-petite-caps;line-height: 1;">{{ displayDate.split(" ")[2] + ' ' + displayDate.split(" ")[3] }}</p>
            </div>
          </div>
          <vs-spacer />
          <div class="vx-col">
            <div style="height: 100%;width: 154px;">
              <vs-button @click="openEventPopup" class="large-btn_icon-only" size="large" type="flat" radius color="success" icon-pack="feather" icon="icon-plus" style="height: 100% !important;width: 100% !important;"/>
            </div>
          </div>
        </div>
        <div v-if="events.length > 0">
          <div class="vx-row mt-4" style="align-items: center;" v-for="(event, index) in events" :key="index">
            <div v-show="event.topicId" class="vx-col w-1/6" style="align-self: center;">
              <p style="font-size:42pt;opacity:0.4"><strong>{{(index + 1) > 0 ? '0' + (index + 1) : (index + 1)}}</strong></p>
            </div>
            <div v-show="event.topicId" class="vx-col w-5/6">
              <span style="display: flex;align-items: baseline;">
                <feather-icon icon="ClockIcon" width="30" height="30" svgClasses="h-4 w-4" class="mr-3 teacher-clock-icon" style="align-self: center;" />
                <p style="font-size:18pt;">{{ event.startTime }}</p>
                <p class="ml-4" style="font-size: 24pt;text-align: left;font-variant: all-petite-caps;line-height: 1;">{{ event.subject }}&nbsp;|&nbsp;<strong>{{ event.title }}</strong></p>
              </span>
              <vs-button class="event-popup_edit-btn school-primary_gradient" radius icon-pack="feather" icon="icon-edit-2" size="large" @click="editEvent(event)" />
              <vs-divider />
              <span style="display: flex;align-items: baseline;">
                <feather-icon icon="ClockIcon" svgClasses="h-4 w-4" class="mr-3 teacher-clock-icon" style="align-self: center;" />
                <p style="font-size:18pt;">{{ event.endTime }}</p>
                <p class="ml-5" v-if="event.grade"  style="font-size: 16pt;text-align: left;font-variant: all-petite-caps;line-height: 1;"><strong>{{ event.grade }}</strong>&nbsp;|&nbsp;{{ event.topic }}</p>
                <p class="ml-5" v-else style="font-size: 16pt;text-align: left;font-variant: all-petite-caps;line-height: 1;"><strong>{{ event.description }}</strong>&nbsp;|&nbsp;{{ 'yo'}}</p>
                
              </span>
            </div>
            

            <div v-show="event.notificationStartDate && !event.homeworkBookTagId && !event.topicId" class="vx-col w-1/6" style="align-self: center;">
              <feather-icon icon="BellIcon" width="30" height="30" svgClasses="h-4 w-4" class="mr-3 notification-bell-icon" style="align-self: center;" />
            </div>
            <div v-show="event.notificationStartDate && !event.homeworkBookTagId && !event.topicId" class="vx-col w-5/6">
              <span style="display: flex;align-items: baseline;">
                <p style="font-size: 24pt;text-align: left;font-variant: all-petite-caps;line-height: 1;"><strong>{{ event.title }}</strong></p>
              </span>
              <p class="mt-2" style="font-size: 11pt;text-align: left;line-height: 1;font-style: italic;">"{{ event.notificationMessage }}"</p>
              <vs-button class="event-popup_edit-btn school-primary_gradient" radius icon-pack="feather" icon="icon-edit-2" size="large" @click="editEvent(event)" />
              <vs-divider />
              <p v-if="event.subjectId" class="mb-2" style="font-size: 18pt;text-align: left;font-variant: all-petite-caps;line-height: 1;"><strong>{{ event.grade }}</strong>&nbsp;|&nbsp;<strong>{{ event.subject }}</strong></p>
              <p v-if="event.classroomId" class="mb-2" style="font-size: 18pt;text-align: left;font-variant: all-petite-caps;line-height: 1;"><strong>{{ event.classroomId}}</strong>&nbsp;|&nbsp;<strong>{{ event.subject }}</strong></p>
              <p v-else class="mb-2" style="font-size: 16pt;text-align: left;font-variant: all-petite-caps;line-height: 1;"><strong>One or more classrooms selected</strong></p>
              <span style="display: flex;align-items: baseline;">
                <feather-icon icon="ClockIcon" svgClasses="h-4 w-4" class="mr-3 teacher-clock-icon_smaller" style="align-self: center;" />
                <p style="font-size:12pt;">{{ formatNotificationDate(event.notificationStartDate) }} - {{ formatNotificationDate(event.notificationEndDate) }}</p>
              </span>
            </div>

            <div v-show="!Array.isArray(event.classroomId) && event.homeworkBookTagId" class="vx-col w-1/6" style="align-self: center;">
              <feather-icon icon="BookIcon" width="30" height="30" svgClasses="h-4 w-4" class="mr-3 notification-bell-icon" style="align-self: center;" />
            </div>
            <div v-show="!Array.isArray(event.classroomId) && event.homeworkBookTagId" class="vx-col w-5/6">
              <span style="display: flex;align-items: baseline;">
                <p style="font-size: 24pt;text-align: left;font-variant: all-petite-caps;line-height: 1;"><strong>{{ event.title }}</strong></p>
              </span>
              <p class="mt-2" style="font-size: 11pt;text-align: left;line-height: 1;font-style: italic;">"{{ event.description }}"</p>
              <vs-button class="event-popup_edit-btn school-primary_gradient" radius icon-pack="feather" icon="icon-edit-2" size="large" @click="editEvent(event)" />
              <vs-divider />
              <p class="mb-2" style="font-size: 18pt;text-align: left;font-variant: all-petite-caps;line-height: 1;"><strong>{{ 'Classroom' }}</strong>&nbsp;|&nbsp;<strong>{{ getClassroom(event.classroomId) }}</strong></p>
              
              <span style="display: flex;align-items: baseline;">
                <feather-icon icon="ClockIcon" svgClasses="h-4 w-4" class="mr-3 teacher-clock-icon_smaller" style="align-self: center;" />
                <p style="font-size:12pt;">All Day</p>
              </span>
            </div>

            <vs-divider border-style="dashed" />
          </div>
        </div>
        <div v-else>
          <p class="mt-4" style="font-size:13pt">There are no events scheduled for <strong>{{noDataDate}}</strong></p>
        </div>
      </div>
    </div>

    <vs-popup id="calendar-popup" ref="calendarpopup" title="" width class="vs-con-loading__container" :active.sync="calendarPopupActive">
      <span class="text__school-font-color" style="display: flex;align-items: center;">
        <feather-icon icon="EditIcon" svgClasses="h-4 w-4" class="mr-3 large-icon" />
        <p style="font-size:18pt;">{{ (streamEventData.id || videoChatEventData.id || notifyEventData.notificationId || homeWorkData.id) ? 'EDIT EVENT' : 'ADD EVENT' }}</p>
      </span>
      <vs-divider border-style="dashed" />

      <vs-tabs id="event-tab-container" v-model="activeTab">
        <vs-tab label="Live Stream">
          <div class="tab-text">
            <div id="event-input_container" class="vx-col mb-3 w-full">
              <p style="font-size:14pt">Title</p>
              <vs-input autocomplete="off" class="w-full mb-2 dark-input_with-border" v-model="streamEventData.name" v-validate="'required'" name="Title"/>

              <p style="font-size:14pt">Description</p>
              <vs-input autocomplete="off" class="w-full dark-input_with-border" v-model="streamEventData.description" v-validate="'required'" name="Description"/>
              <div>
                <vs-checkbox class="mt-3" style="font-size:14pt" color="success" v-model="streamEventData.includeChat">Enable Chatroom</vs-checkbox>
              </div>

              <div v-if="streamEventData.id" class="mt-2">
                <div class="vx-row mb-2" style="align-items: flex-end;">
                  <div class="vx-col w-5/6">
                    <p style="font-size:14pt">Live Stream Server URL</p>
                    <vs-input :disabled="true" autocomplete="off" class="w-full dark-input_with-border" v-model="streamEventData.liveStreamUrl"/>
                  </div>
                  <div class="vx-col w-1/6">
                    <vs-button color="primary" radius icon-pack="feather" icon="icon-copy" v-clipboard:copy="streamEventData.liveStreamUrl" v-clipboard:success="onLinkCopy" />
                  </div>
                </div>

                <div class="vx-row" style="align-items: flex-end;">
                  <div class="vx-col w-5/6">
                    <p style="font-size:14pt">Live Stream Name (Key)</p>
                    <vs-input :disabled="true" autocomplete="off" class="w-full mb-2 dark-input_with-border" v-model="streamEventData.liveStreamName"/>
                  </div>
                  <div class="vx-col w-1/6">
                    <vs-button class="mb-3" color="primary" radius icon-pack="feather" icon="icon-copy" v-clipboard:copy="streamEventData.liveStreamName" v-clipboard:success="onNameCopy" />
                  </div>
                </div>
              </div>
            </div>

            <div class="mb-2">
              <p style="font-size:14pt">Subject</p>
              <vx-card class="glow-effect_dark card__no-padding bg-color">
                <vx-input-group style="height: 50px;">
                  <template slot="prepend">
                    <div class="prepend-text school-primary_gradient">
                      <span><feather-icon class="pt-1" icon="BookIcon" svg-classes="stroke-current"></feather-icon></span>
                    </div>
                  </template>

                  <v-select
                    ref="streamSubjectDropdown"
                    class="w-full style-chooser teacher-schedule-dropdown"
                    placeholder="Search / Select a Subject"
                    :options="subjects"
                    @search:blur="selectSubject"
                    v-model="streamSubjectDropdown"
                  />
                </vx-input-group>
              </vx-card>
            </div>

            <div class="mb-5">
              <p style="font-size:14pt">Topic</p>
              <vx-card class="glow-effect_dark card__no-padding bg-color">
                <vx-input-group style="height: 50px;">
                  <template slot="prepend">
                    <div class="prepend-text school-primary_gradient">
                      <span><feather-icon class="pt-1" icon="DiscIcon" svg-classes="stroke-current"></feather-icon></span>
                    </div>
                  </template>

                  <v-select
                    ref="topicDropdown"
                    class="w-full style-chooser teacher-schedule-dropdown"
                    placeholder="Search / Select a Topic"
                    :options="topics"
                    v-model="topicDropdown"
                  />
                </vx-input-group>
              </vx-card>
            </div>

            <div v-if="streamEventData.classrooms.length > 0" class="mb-3">
              <vs-collapse class="border dark-background">
                <vs-collapse-item>
                  <div slot="header">
                    Classrooms <small>(Optional)</small>
                  </div>

                  <div class="vx-col w-full">
                    <vs-table id="classroom-table" class="vs-con-loading__container mx-auto" stripe single pagination search max-items="5" :data="streamEventData.classrooms">

                    <template slot="thead">
                      <vs-th>Classroom</vs-th>
                      <vs-th>Applied To</vs-th>
                    </template>

                    <template slot-scope="{data}">

                      <vs-tr :data="classroom" :key="index" v-for="(classroom, index) in data">

                        <vs-td>
                          {{ classroom.name }}
                        </vs-td>

                        <vs-td>
                          <!-- <p-check class="ml-2 p-default p-curve p-fill p-icon p-smooth" v-model="classroom.selected" color="success">
                            <i class="icon feather icon-check" slot="extra"></i>
                          </p-check> -->
                          <p-check v-model="classroom.selected" />
                        </vs-td>

                      </vs-tr>
                    </template>
                  </vs-table>
                  </div>
                </vs-collapse-item>
              </vs-collapse>
            </div>

            <div class="vx-row">
              <div class="vx-col xs:w-full sm:w-full md:w-full lg:w-1/3 xl:w-1/3">
                <p style="font-size:14pt">Date</p>
                <vx-card class="glow-effect_dark mb-3 card__no-padding bg-color">
                  <vx-input-group style="height: 50px;">
                    <template slot="prepend">
                      <div class="prepend-text school-primary_gradient">
                        <span><feather-icon class="pt-1" icon="CalendarIcon" svg-classes="stroke-current"></feather-icon></span>
                      </div>
                    </template>

                    <vs-input class="date-input_disabled" :disabled="true" v-model="streamEventData.date" />
                  </vx-input-group>
                </vx-card>
              </div>
              <div class="vx-col xs:w-1/2 sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3">
                <p style="font-size:14pt">Start</p>
                <vx-card class="glow-effect_dark mb-3 card__no-padding bg-color">
                  <vx-input-group style="height: 50px;">
                    <template slot="prepend">
                      <div class="prepend-text school-primary_gradient">
                        <span><feather-icon class="pt-1" icon="ClockIcon" svg-classes="stroke-current"></feather-icon></span>
                      </div>
                    </template>

                    <vue-clock-picker
                      ref="streamStartTimePicker"
                      class="custom-classes__time-picker"
                      v-model="streamEventData.startTime"
                      close-on-esc
                      close-on-overlay
                      font="Montserrat"
                      done-text="Done"
                      cancel-text="Cancel"
                      active-color="#ecf01a"
                      color="#ffffff"
                    />
                  </vx-input-group>
                </vx-card>
              </div>
              <div class="vx-col xs:w-1/2 sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3">
                <p style="font-size:14pt">End</p>
                <vx-card class="glow-effect_dark mb-3 card__no-padding bg-color">
                  <vx-input-group style="height: 50px;">
                    <template slot="prepend">
                      <div class="prepend-text school-primary_gradient">
                        <span><feather-icon class="pt-1" icon="ClockIcon" svg-classes="stroke-current"></feather-icon></span>
                      </div>
                    </template>

                    <vue-clock-picker
                      ref="streamEndTimePicker"
                      class="custom-classes__time-picker"
                      v-model="streamEventData.endTime"
                      close-on-esc
                      close-on-overlay
                      font="Montserrat"
                      done-text="Done"
                      cancel-text="Cancel"
                      active-color="#ecf01a"
                      color="#ffffff"
                    />
                  </vx-input-group>
                </vx-card>
              </div>
            </div>

            <vs-divider />

            <div class="vx-row mt-3">
              <vs-spacer/>
              <div class="vx-col">
                <vs-button ref="saveStreamButton" class="event-popup_action-btns" :disabled="isSaveStreamDisabled" icon-pack="feather" icon="icon-check" size="large" color="success" @click="saveStreamEvent" />
              </div>
              <div v-if="streamEventData.id" class="vx-col">
                <vs-button ref="deleteStreamButton" class="event-popup_action-btns" icon-pack="feather" icon="icon-trash-2" size="large" color="danger" @click="deleteStreamEvent" />
              </div>
              <div class="vx-col">
                <vs-button class="event-popup_action-btns" icon-pack="feather" icon="icon-x" size="large" color="warning" @click="calendarPopupActive = false" />
              </div>
            </div>
          </div>
        </vs-tab>
        <vs-tab label="Reminders">
          <div class="tab-text">
            <div id="event-input_container" class="vx-col w-full">
              <p style="font-size:14pt">Title</p>
              <vs-input autocomplete="off" class="w-full mb-2 dark-input_with-border" v-model="notifyEventData.title" v-validate="'required'" name="Title"/>

              <p style="font-size:14pt">Message</p>
              <vs-textarea autocomplete="off" class="w-full dark-textarea" v-model="notifyEventData.message" v-validate="'required'" name="Description"/>
            </div>

            <div class="vx-row mt-3">
              <div class="vx-col w-full" style="text-align: left;">
                <p style="font-size:14pt">Apply To...</p>
              </div>
            </div>
            <div class="vx-row mt-2 mb-3">
              <div class="vx-col w-full" style="text-align: left;">
                <p-radio class="p-round p-fill p-smooth p-bigger" color="success" v-model="notifyType" :value="0">Subject</p-radio>
                <p-radio class="p-round p-fill p-smooth p-bigger" color="success" v-model="notifyType" :value="1">Classroom(s)</p-radio>
              </div>
            </div>

            <div v-if="notifyType == 0" class="mb-4">
              <p style="font-size:14pt">Subject</p>
              <vx-card class="glow-effect_dark card__no-padding bg-color">
                <vx-input-group style="height: 50px;">
                  <template slot="prepend">
                    <div class="prepend-text school-primary_gradient">
                      <span><feather-icon class="pt-1" icon="BookIcon" svg-classes="stroke-current"></feather-icon></span>
                    </div>
                  </template>

                  <v-select
                    ref="subjectDropdown"
                    class="w-full style-chooser teacher-schedule-dropdown"
                    placeholder="Search / Select a Subject"
                    :options="subjects"
                    @search:blur="selectSubject"
                    v-model="subjectDropdown"
                  />
                </vx-input-group>
              </vx-card>
            </div>

            <div v-if="notifyType == 1 && notifyEventData.classrooms.length > 0" class="mb-3">
              <vs-collapse class="border dark-background">
                <vs-collapse-item>
                  <div slot="header">
                    Classrooms
                  </div>

                  <div class="vx-col w-full">
                    <vs-table id="classroom-table" class="vs-con-loading__container mx-auto" stripe single pagination search max-items="5" :data="notifyEventData.classrooms">

                      <template slot="thead">
                        <vs-th>Classroom</vs-th>
                        <vs-th>Applied To</vs-th>
                      </template>

                      <template slot-scope="{data}">

                        <vs-tr :data="classroom" :key="index" v-for="(classroom, index) in data">

                          <vs-td>
                            {{ classroom.name }}
                          </vs-td>

                          <vs-td>
                            <vs-checkbox v-model="classroom.selected" />
                          </vs-td>

                        </vs-tr>
                      </template>
                    </vs-table>
                  </div>
                </vs-collapse-item>
              </vs-collapse>
            </div>

            <div class="vx-row mb-3">
              <div class="vx-col w-1/2">
                <h3 class="text__school-font-color text-center mb-3">START DATE & TIME</h3>
                <datepicker ref="fromPicker" v-model="notifyEventData.fromDate" :inline="true" :format="format" :highlighted="highlightedFn"></datepicker>
                <vx-card class="glow-effect_dark mt-2 card__no-padding bg-color">
                  <vx-input-group style="height: 50px;">
                    <template slot="prepend">
                      <div class="prepend-text school-primary_gradient">
                        <span><feather-icon class="pt-1" icon="ClockIcon" svg-classes="stroke-current"></feather-icon></span>
                      </div>
                    </template>

                    <vue-clock-picker
                      ref="notifyStartTimePicker"
                      class="custom-classes__time-picker"
                      v-model="notifyEventData.startTime"
                      close-on-esc 
                      close-on-overlay
                      font="Montserrat"
                      done-text="Done"
                      cancel-text="Cancel"
                      active-color="#ecf01a"
                      color="#ffffff"
                    />
                  </vx-input-group>
                </vx-card>
              </div>
              <div class="vx-col w-1/2">
                <h3 class="text__school-font-color text-center mb-3">END DATE & TIME</h3>
                <datepicker ref="toPicker" v-model="notifyEventData.toDate" :inline="true" :format="format" :highlighted="highlightedFn"></datepicker>
                <vx-card class="glow-effect_dark mt-2 card__no-padding bg-color">
                  <vx-input-group style="height: 50px;">
                    <template slot="prepend">
                      <div class="prepend-text school-primary_gradient">
                        <span><feather-icon class="pt-1" icon="ClockIcon" svg-classes="stroke-current"></feather-icon></span>
                      </div>
                    </template>

                    <vue-clock-picker
                      ref="notifyEndTimePicker"
                      class="custom-classes__time-picker"
                      v-model="notifyEventData.endTime"
                      close-on-esc 
                      close-on-overlay
                      font="Montserrat"
                      done-text="Done"
                      cancel-text="Cancel"
                      active-color="#ecf01a"
                      color="#ffffff"
                    />
                  </vx-input-group>
                </vx-card>
              </div>
            </div>

            <vs-divider />

            <div class="vx-row mt-3">
              <vs-spacer/>
              <div class="vx-col">
                <vs-button ref="saveNotifyButton" class="event-popup_action-btns" :disabled="isSaveNotifyDisabled" icon-pack="feather" icon="icon-check" size="large" color="success" @click="saveNotifyEvent" />
              </div>
              <div v-if="notifyEventData.notificationId" class="vx-col">
                <vs-button ref="deleteNotifyButton" class="event-popup_action-btns" icon-pack="feather" icon="icon-trash-2" size="large" color="danger" @click="deleteNotifyEvent" />
              </div>
              <div class="vx-col">
                <vs-button class="event-popup_action-btns" icon-pack="feather" icon="icon-x" size="large" color="warning" @click="calendarPopupActive = false" />
              </div>
            </div>
          </div>
        </vs-tab>
        <vs-tab label="Video Chat">
          <div class="tab-text">
            <div id="event-input_container" class="vx-col mb-3 w-full">
              <p style="font-size:14pt">Title</p>
              <vs-input autocomplete="off" class="w-full mb-2 dark-input_with-border" v-model="videoChatEventData.name" v-validate="'required'" name="Title"/>

              <p style="font-size:14pt">Description</p>
              <vs-input autocomplete="off" class="w-full dark-input_with-border" v-model="videoChatEventData.description" v-validate="'required'" name="Description"/>

              <div class="vx-row my-2" style="align-items: flex-end;">
                <div class="vx-col w-1/2">
                  <span class="flex">
                    <p style="font-size:14pt">Zoom Invite URL</p>
                    <div class="ml-3 cursor-pointer" style="align-self: flex-end;">
                      <svg @click="showGoogleMeetHelp" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-help-circle"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>
                    </div>
                  </span>
                  <vs-input autocomplete="off" class="w-full dark-input_with-border" v-model="videoChatEventData.googleMeetUrl"/>
                </div>
                <div class="vx-col w-1/2">
                  <vs-button color="success" icon-pack="feather" icon="icon-external-link" icon-after @click="openGoogleMeet">Zoom Invite URL</vs-button>
                </div>
              </div>
            </div>

            <div class="mb-2">
              <p style="font-size:14pt">Subject</p>
              <vx-card class="glow-effect_dark card__no-padding bg-color">
                <vx-input-group style="height: 50px;">
                  <template slot="prepend">
                    <div class="prepend-text school-primary_gradient">
                      <span><feather-icon class="pt-1" icon="BookIcon" svg-classes="stroke-current"></feather-icon></span>
                    </div>
                  </template>

                  <v-select
                    ref="videoChatSubjectDropdown"
                    class="w-full style-chooser teacher-schedule-dropdown"
                    placeholder="Search / Select a Subject"
                    :options="subjects"
                    @search:blur="selectSubject"
                    v-model="videoChatSubjectDropdown"
                  />
                </vx-input-group>
              </vx-card>
            </div>

            <div class="mb-5">
              <p style="font-size:14pt">Topic</p>
              <vx-card class="glow-effect_dark card__no-padding bg-color">
                <vx-input-group style="height: 50px;">
                  <template slot="prepend">
                    <div class="prepend-text school-primary_gradient">
                      <span><feather-icon class="pt-1" icon="DiscIcon" svg-classes="stroke-current"></feather-icon></span>
                    </div>
                  </template>

                  <v-select
                    ref="topicDropdown"
                    class="w-full style-chooser teacher-schedule-dropdown"
                    placeholder="Search / Select a Topic"
                    :options="topics"
                    v-model="topicDropdown"
                  />
                </vx-input-group>
              </vx-card>
            </div>

            <div v-if="videoChatEventData.classrooms.length > 0" class="mb-3">
              <vs-collapse class="border dark-background">
                <vs-collapse-item>
                  <div slot="header">
                    Classrooms <small>(Optional)</small>
                  </div>

                  <div class="vx-col w-full">
                    <vs-table id="classroom-table" class="vs-con-loading__container mx-auto" stripe single pagination search max-items="5" :data="videoChatEventData.classrooms">

                    <template slot="thead">
                      <vs-th>Classroom</vs-th>
                      <vs-th>Applied To</vs-th>
                    </template>

                    <template slot-scope="{data}">

                      <vs-tr :data="classroom" :key="index" v-for="(classroom, index) in data">

                        <vs-td>
                          {{ classroom.name }}
                        </vs-td>

                        <vs-td>
                          <!-- <p-check class="ml-2 p-default p-curve p-fill p-icon p-smooth" v-model="classroom.selected" color="success">
                            <i class="icon feather icon-check" slot="extra"></i>
                          </p-check> -->
                          <p-check v-model="classroom.selected" />
                        </vs-td>

                      </vs-tr>
                    </template>
                  </vs-table>
                  </div>
                </vs-collapse-item>
              </vs-collapse>
            </div>

            <div class="vx-row">
              <div class="vx-col xs:w-full sm:w-full md:w-full lg:w-1/3 xl:w-1/3">
                <p style="font-size:14pt">Date</p>
                <vx-card class="glow-effect_dark mb-3 card__no-padding bg-color">
                  <vx-input-group style="height: 50px;">
                    <template slot="prepend">
                      <div class="prepend-text school-primary_gradient">
                        <span><feather-icon class="pt-1" icon="CalendarIcon" svg-classes="stroke-current"></feather-icon></span>
                      </div>
                    </template>

                    <vs-input class="date-input_disabled" :disabled="true" v-model="videoChatEventData.date" />
                  </vx-input-group>
                </vx-card>
              </div>
              <div class="vx-col xs:w-1/2 sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3">
                <p style="font-size:14pt">Start</p>
                <vx-card class="glow-effect_dark mb-3 card__no-padding bg-color">
                  <vx-input-group style="height: 50px;">
                    <template slot="prepend">
                      <div class="prepend-text school-primary_gradient">
                        <span><feather-icon class="pt-1" icon="ClockIcon" svg-classes="stroke-current"></feather-icon></span>
                      </div>
                    </template>

                    <vue-clock-picker
                      ref="streamStartTimePicker"
                      class="custom-classes__time-picker"
                      v-model="videoChatEventData.startTime"
                      close-on-esc
                      close-on-overlay
                      font="Montserrat"
                      done-text="Done"
                      cancel-text="Cancel"
                      active-color="#ecf01a"
                      color="#ffffff"
                    />
                  </vx-input-group>
                </vx-card>
              </div>
              <div class="vx-col xs:w-1/2 sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3">
                <p style="font-size:14pt">End</p>
                <vx-card class="glow-effect_dark mb-3 card__no-padding bg-color">
                  <vx-input-group style="height: 50px;">
                    <template slot="prepend">
                      <div class="prepend-text school-primary_gradient">
                        <span><feather-icon class="pt-1" icon="ClockIcon" svg-classes="stroke-current"></feather-icon></span>
                      </div>
                    </template>

                    <vue-clock-picker
                      ref="streamEndTimePicker"
                      class="custom-classes__time-picker"
                      v-model="videoChatEventData.endTime"
                      close-on-esc
                      close-on-overlay
                      font="Montserrat"
                      done-text="Done"
                      cancel-text="Cancel"
                      active-color="#ecf01a"
                      color="#ffffff"
                    />
                  </vx-input-group>
                </vx-card>
              </div>
            </div>

            <vs-divider />

            <div class="vx-row mt-3">
              <vs-spacer/>
              <div class="vx-col">
                <vs-button ref="saveVideoChatButton" class="event-popup_action-btns" :disabled="isVideoChatDisabled" icon-pack="feather" icon="icon-check" size="large" color="success" @click="saveVideoChatEvent" />
              </div>
              <div v-if="videoChatEventData.id" class="vx-col">
                <vs-button ref="deleteVideoChatButton" class="event-popup_action-btns" icon-pack="feather" icon="icon-trash-2" size="large" color="danger" @click="deleteVideoChatEvent" />
              </div>
              <div class="vx-col">
                <vs-button class="event-popup_action-btns" icon-pack="feather" icon="icon-x" size="large" color="warning" @click="calendarPopupActive = false" />
              </div>
            </div>
          </div>
        </vs-tab>
        <vs-tab label="Task Notifications">
          <div class="tab-text">
            <div id="event-input_container" class="vx-col mb-3 w-full">
              <p style="font-size:14pt">Title</p>
              <vs-input autocomplete="off" class="w-full mb-2 dark-input_with-border" v-model="homeWorkData.name" v-validate="'required'" name="Title"/>

              <p style="font-size:14pt">Description</p>
              <vs-input autocomplete="off" class="w-full dark-input_with-border" v-model="homeWorkData.description" v-validate="'required'" name="Description"/>
            </div>

            <div v-if="homeWorkData.classrooms.length > 0" class="mb-3">
              <vs-collapse class="border dark-background">
                <vs-collapse-item>
                  <div slot="header">
                    Select a Classrooms
                  </div>

                  <div class="vx-col w-full">
                    <vs-table id="classroom-table" class="vs-con-loading__container mx-auto" stripe single pagination search max-items="5" :data="homeWorkData.classrooms">

                    <template slot="thead">
                      <vs-th>Classroom</vs-th>
                      <vs-th>Applied To</vs-th>
                    </template>

                    <template slot-scope="{data}">

                      <vs-tr :data="classroom" :key="index" v-for="(classroom, index) in data"   >

                        <vs-td>
                          {{ classroom.name }}
                        </vs-td>

                        <vs-td>
                          <!-- <p-check class="ml-2 p-default p-curve p-fill p-icon p-smooth" v-model="classroom.selected" color="success">
                            <i class="icon feather icon-check" slot="extra"></i>
                          </p-check> -->
                          <p-check v-model="classroom.selected"  :disabled="isButtonDisabled.selected ? isButtonDisabled.id != classroom.id ? true : false :false" />
                        </vs-td>

                      </vs-tr>
                    </template>
                  </vs-table>
                  </div>
                </vs-collapse-item>
              </vs-collapse>
            </div>

            <div class="vx-row">
              <div class="vx-col xs:w-full sm:w-full md:w-1/2 lg:w-1/3 xl:w-1/3">
                <p style="font-size:14pt">Due Date</p>
                <vx-card class="glow-effect_dark mb-3 card__no-padding bg-color">
                  <vx-input-group style="height: 50px;">
                    <template slot="prepend">
                      <div class="prepend-text school-primary_gradient">
                        <span><feather-icon class="pt-1" icon="CalendarIcon" svg-classes="stroke-current"></feather-icon></span>
                      </div>
                    </template>

                    <vs-input class="date-input_disabled" :disabled="true" v-model="homeWorkData.date" />
                  </vx-input-group>
                </vx-card>
              </div>
              <vs-spacer/>
              <div class="vx-col xs:w-full sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/2 float-right" style="display: flex; flex-direction: column;">
                <p style="font-size:14pt; height: 42px;">Priority</p>
                <div class="vx-row">
                  <div class="vx-col flex-1" v-for="(items, index) in tags" :key="index" >
                    <p-radio  :color="index == 0 ? 'success': index==1 ? 'warning':'danger' " :value="index"  v-model="tagDropdown" >{{items.label}}</p-radio>
                  </div>
                </div>
                <!--<v-select
                    ref="tagDropdown"
                    class="w-full style-chooser teacher-schedule-dropdown"
                    placeholder="Select a Priority"
                    :options="tags"
                    v-model="tagDropdown"
                  />-->
              </div>
              
            </div>

            <vs-divider />

            <div class="vx-row mt-3">
              <vs-spacer/>
              <div class="vx-col">
                <vs-button ref="saveStreamButton" class="event-popup_action-btns" :disabled="isSaveHomeWorkDisabled" icon-pack="feather" icon="icon-check" size="large" color="success" @click="saveHomework" />
              </div>
              <div v-if="homeWorkData.id" class="vx-col">
                <vs-button ref="deleteStreamButton" class="event-popup_action-btns" icon-pack="feather" icon="icon-trash-2" size="large" color="danger" @click="deleteHomeWork" />
              </div>
              <div class="vx-col">
                <vs-button class="event-popup_action-btns" icon-pack="feather" icon="icon-x" size="large" color="warning" @click="calendarPopupActive = false" />
              </div>
            </div>
          </div>
        </vs-tab>
      </vs-tabs>
      
      <vs-popup id="google-meet_help-popup" title="Where to find the Zoom Invite URL?" :active.sync="googleMeetHelpPopupActive">
        <img src="https://lateralscaffolding.blob.core.windows.net/resources/google-meet-help.png" style="width: inherit;">
      </vs-popup>
    </vs-popup>
  </div>
</template>


<script>
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker';
import moment from 'moment'
import flatPickr from 'vue-flatpickr-component';
import VueClockPicker from '@pencilpix/vue2-clock-picker';
import '@pencilpix/vue2-clock-picker/dist/vue2-clock-picker.min.css';
export default {
  components: {
    vSelect,
    Datepicker,
    moment,
    flatPickr,
    VueClockPicker
  },
  data() {
    return {
      tagDropdown:0,
      tags:[],
      googleMeetHelpPopupActive: false,
      activeTab: 0,
      events: [],
      calendarPopupActive: false,
      includeChat: false,
      selectedIndex:{
        id:0,
        selected:false,
      },
      streamEventData: {
        id: 0,
        name: "",
        description: "",
        moduleId: 0,
        date: null,
        startTime: null,
        endTime: null,
        liveStreamName: "",
        liveStreamUrl: "",
        classrooms: [],
        includeChat: false,
      },
      homeWorkData: {
        id: 0,
        name: "",
        description: "",
        moduleId: 0,
        date: null,
        toDate: null,
        classrooms: [],
      },
      videoChatEventData: {
        id: 0,
        name: "",
        description: "",
        moduleId: 0,
        date: null,
        startTime: null,
        endTime: null,
        googleMeetUrl: "",
        classrooms: []
      },
      currentUserId: null,
      pickerDate: new Date(),
      format: "yyyy-MM-dd",
      highlightedFn: {
        customPredictor(date) {
          var today = new Date();
          
          if (date.getDate() == today.getDate() && date.getMonth() == today.getMonth()) {
            return true;
          }
        }
      },
      subjects: [],
      streamSubjectDropdown: 0,
      videoChatSubjectDropdown: 0,
      subjectDropdown: 0,
      topics: [],
      topicDropdown: 0,
      noDataDate: null,
      currentDay: null,
      dataToSend: {
        id:0,
        title: "",
        classroomId: 0,
        description: "",
        dueDate: new Date(),
        homeworkBookTagId: 0,
      },
      notifyEventData: {
        notificationId: 0,
        title:"",
        name: "",
        message: "",
        courseId: 0,
        fromDate: new Date(),
        toDate: new Date(),
        startTime: null,
        endTime: null,
        classrooms: []
      },
      notifyType: 0
    };
  },
  watch: {
    

    calendarPopupActive: function(val) {
      var self = this;
      if(!val) {
        self.initValues();
      }
    },
    pickerDate: function(val) {
      this.getEvents(val);
    },
    activeTab: function(val) {
      var self = this;
      if (val == 0) {
        if (!self.streamEventData.id)
          self.streamSubjectDropdown = 0;

        setTimeout(function () {
          self.setStreamStartTime();
          self.setStreamEndTime();
        }, 500)
      }
      else if (val == 1) {
        if (!self.notifyEventData.notificationId) {
          self.initValues();
        }

        self.subjectDropdown = 0;
        setTimeout(function () {
          self.setNotifyStartTime();
          self.setNotifyEndTime();
        }, 500)
      }
      else if (val == 2) {
        if (!self.videoChatEventData.id)
          self.videoChatSubjectDropdown = 0;

        setTimeout(function () {
          self.setStreamStartTime();
          self.setStreamEndTime();
        }, 500)
      }
    },
    notifyType: function() {
      this.subjectDropdown = 0;
      if (!this.notifyEventData.notificationId) {
        this.notifyEventData.classrooms.forEach(function(item) {
          item.selected = false;
        });
      }
    }
  },
  computed: {
    displayDate: function() {
      var self = this;
      if(self.pickerDate) {
        var dateString = new Date(Date.parse(self.pickerDate));

        var result = moment(dateString.toISOString()).format("dddd DD MMMM YYYY");
        self.streamEventData.date = result;
        self.videoChatEventData.date = result;
        self.homeWorkData.date = result;

        self.noDataDate = moment(dateString.toISOString()).format("dddd, Do MMMM YYYY");

        self.currentDay = moment(new Date()).format("dddd");

        return result;
      }
    },
    isButtonDisabled: function(){
      var self = this;
      self.isButtonClicked();
      self.homeWorkData.classrooms.forEach(element => {
        if(element.selected)
        {
          self.selectedIndex.id = element.id;
          self.selectedIndex.selected = true;
          return self.selectedIndex;
        }
        
      });
      return self.selectedIndex;
    },
    isSaveStreamDisabled: function() {
      var isTimeSelected = this.streamEventData.startTime && this.streamEventData.endTime ? true : false;
      this.includeChat = this.streamEventData.includeChat ? true : false;
      var isAtLeastOneClassSelected = this.streamEventData.classrooms.filter(function(item) { return item.selected; }).length > 0;

      return !this.topicDropdown.value && (!isTimeSelected || !isAtLeastOneClassSelected);
    },
    isSaveNotifyDisabled: function() {
      var isAtLeastOneClassSelected = this.notifyEventData.classrooms.filter(function(item) { return item.selected; }).length > 0;

      return (this.notifyType == 0 && (!this.subjectDropdown || !this.subjectDropdown.value)) || (this.notifyType == 1 && !isAtLeastOneClassSelected);
    },
    isSaveHomeWorkDisabled: function() {
      var isAtLeastOneClassSelected = this.homeWorkData.classrooms.filter(function(item) { return item.selected; }).length > 0;
      return this.homeWorkData.title == undefined && !isAtLeastOneClassSelected;
    },
    isVideoChatDisabled: function() {
      var isTimeSelected = this.videoChatEventData.startTime && this.videoChatEventData.endTime ? true : false;
      var isAtLeastOneClassSelected = this.videoChatEventData.classrooms.filter(function(item) { return item.selected; }).length > 0;

      return !this.topicDropdown.value && (!isTimeSelected || !isAtLeastOneClassSelected);
    },
  },
  methods: {
    isButtonClicked() {
      var self = this;
      if(self.selectedIndex.selected)
      {
        self.selectedIndex.selected = false;
      }
    },
    getPriority(){
      var self = this;
      var onSuccess = response => {
        self.tags = response.data.map(x=>{return{label:x.text, value:x.value , selected:false}});
      };
      
      self.$ajaxGet(self, "HomeworkBook/GetHomeworkTagListForSite", onSuccess);
    },
    openGoogleMeet() {
      if (this.videoChatEventData.id) {
        window.open(`${this.videoChatEventData.googleMeetUrl}`);
      }
      else {
        window.open('https://us04web.zoom.us/meeting/schedule');
      }
    },
    showGoogleMeetHelp() {
      this.googleMeetHelpPopupActive = true;
    },
    setStreamStartTime() {
      if (this.$refs.streamStartTimePicker && !this.$refs.streamStartTimePicker.getValue()) {
        var fullDate = new Date();
        var hour = fullDate.getHours();
        var minutes = fullDate.getMinutes();
        if (minutes < 30) {
          minutes = 30;
        }
        else {
          minutes = 0;
          hour += 1;
        }

        if (hour < 10) {
          hour = "0" + hour;
        }

        if (minutes < 10) {
          minutes = "0" + minutes;
        }

        var time = hour + ":" + minutes;

        this.$refs.streamStartTimePicker.setValue(time);
      }
    },
    setStreamEndTime() {
      if (this.$refs.streamEndTimePicker && !this.$refs.streamEndTimePicker.getValue()) {
        var fullDate = new Date();
        var hour = fullDate.getHours();
        var minutes = fullDate.getMinutes();
        if (minutes < 30) {
          minutes = 30;
        }
        else {
          minutes = 0;
          hour += 1;
        }

        if (minutes == 0) {
          minutes = 30;
        }
        else {
          minutes = 0;
          hour += 1;
        }

        if (hour < 10) {
          hour = "0" + hour;
        }

        if (minutes < 10) {
          minutes = "0" + minutes;
        }

        var time = hour + ":" + minutes;

        this.$refs.streamEndTimePicker.setValue(time);
      }
    },
    setNotifyStartTime() {
      if (this.$refs.notifyStartTimePicker && !this.$refs.notifyStartTimePicker.getValue()) {
        var fullDate = new Date();
        var hour = fullDate.getHours();
        var minutes = fullDate.getMinutes();
        if (minutes < 30) {
          minutes = 30;
        }
        else {
          minutes = 0;
          hour += 1;
        }

        if (hour < 10) {
          hour = "0" + hour;
        }

        if (minutes < 10) {
          minutes = "0" + minutes;
        }

        var time = hour + ":" + minutes;

        this.$refs.notifyStartTimePicker.setValue(time);
      }
    },
    setNotifyEndTime() {
      if (this.$refs.notifyEndTimePicker && !this.$refs.notifyEndTimePicker.getValue()) {
        var fullDate = new Date();
        var hour = fullDate.getHours();
        var minutes = fullDate.getMinutes();
        if (minutes < 30) {
          minutes = 30;
        }
        else {
          minutes = 0;
          hour += 1;
        }

        if (minutes == 0) {
          minutes = 30;
        }
        else {
          minutes = 0;
          hour += 1;
        }

        if (hour < 10) {
          hour = "0" + hour;
        }

        if (minutes < 10) {
          minutes = "0" + minutes;
        }

        var time = hour + ":" + minutes;

        this.$refs.notifyEndTimePicker.setValue(time);
      }
    },
    openEventPopup() {
      var self = this;
      self.initValues();
      this.calendarPopupActive = true;
      setTimeout(function () {
        self.setStreamStartTime();
        self.setStreamEndTime();
      }, 500)
    },
    initValues() {
      this.activeTab = 0;
      this.streamEventData.id = 0;
      this.streamEventData.name = "";
      this.streamEventData.description = "";
      this.streamEventData.moduleId = 0;
      this.streamEventData.startTime = null;
      this.streamEventData.endTime = null;
      this.streamEventData.liveStreamName = null;
      this.streamEventData.liveStreamUrl = null;
      this.streamEventData.includeChat = false;
      this.setStreamStartTime();
      this.setStreamEndTime();
      this.streamSubjectDropdown = 0;
      this.videoChatSubjectDropdown = 0;
      this.topicDropdown = 0;
      this.streamEventData.classrooms.forEach(function(item) {
        item.selected = false;
      });
      this.homeWorkData.id= 0;
      this.homeWorkData.name ="";
      this.homeWorkData.description= "";
      this.homeWorkData.moduleId= 0;
      this.homeWorkData.toDate= null;
      this.homeWorkData.classrooms.forEach(function(item) {
        item.selected = false;
      });

      this.notifyEventData.notificationId = 0;
      this.notifyEventData.title = "";
      this.notifyEventData.message = "";
      this.notifyEventData.courseId = 0;
      this.notifyEventData.fromDate = new Date();
      this.notifyEventData.toDate = new Date();
      this.notifyEventData.startTime = null;
      this.notifyEventData.endTime = null;
      this.notifyType = 0;
      this.setNotifyStartTime();
      this.setNotifyEndTime();
      this.subjectDropdown = 0;
      this.notifyEventData.classrooms.forEach(function(item) {
        item.selected = false;
      });

      this.videoChatEventData.id = 0;
      this.videoChatEventData.name = "";
      this.videoChatEventData.description = "";
      this.videoChatEventData.moduleId = 0;
      this.videoChatEventData.startTime = null;
      this.videoChatEventData.endTime = null;
      this.videoChatEventData.googleMeetUrl = null;
      this.videoChatEventData.classrooms.forEach(function(item) {
        item.selected = false;
      });
    },
    getClassrooms() {
      var self = this;

      var onSuccess = response => {
        self.streamEventData.classrooms = response.data;
        self.notifyEventData.classrooms = response.data;
        self.videoChatEventData.classrooms = response.data;
        self.homeWorkData.classrooms = response.data;
      };
      
      self.$ajaxGet(self, "Company/ListTeacherClassrooms", onSuccess);
    },
    getSubjects(whenDone) {
      var self = this;

      var onSuccess = response => {
        self.subjects = response.data.map((item) => {return {label: item.text, value: item.value} });
        if (whenDone && typeof whenDone == "function")
          whenDone();
      };
      
      self.$ajaxGet(self, "Course/GetSelectList", onSuccess);
    },
    getTopics(val, whenDone) {
      var self = this;
      self.showLoadingOnElement("topicDropdown", 0.45, "material");
      
      self.topics = []
      self.topicDropdown = 0;

      var onSuccess = response => {
        self.topics = response.data.map((item) => {return {label: item.text, value: item.value} });
        if (whenDone && typeof whenDone == "function")
          whenDone();
      };
      var onFinally = function(response) {
        self.$vs.loading.close(self.$refs.topicDropdown.$el);
      };

      self.$ajaxGet(self, "Module/GetSelectList/" + val, onSuccess, onFinally);
    },
    getEvents(date) {
      var self = this;
      self.showLoadingOnElement('events_page', 1.5, 'material');

      var dateObject = new Date(Date.parse(date));
      var formattedDate = moment(dateObject.toISOString()).format('YYYY-MM-DD');
      
      var onSuccess = function(response) {
        if (response.data && response.data.length >= 0) {
          self.events = response.data;
          self.getHomeworkEvents(self.pickerDate);
        }
      };

      var onFinally = function(response) {
        self.$vs.loading.close(self.$refs.events_page.$el);
      };

      self.$ajaxGet(self, "Schedule/GetUserSchedules?date=" + formattedDate, onSuccess, onFinally);
    },
    getClassroom(id){
      var self = this;
      if(id){
        return  self.homeWorkData.classrooms.filter(item => item.id == id)[0].name;
      }
      else
        return '';
    },
    getHomeworkEvents(date){
      var self= this;
      var dateObject = new Date(Date.parse(date));
      var formattedDate = moment(dateObject.toISOString()).format('YYYY-MM-DD');
      var onSuccess = function(response) {
        if (response.data && response.data.length >= 0) {
          response.data.forEach(element => {
            element.date = element.dueDate;
            self.events.push(element);
          });
        }
      };
      self.$ajaxGet(self, "HomeworkBook/GetHomeworkListForDate?date=" + formattedDate, onSuccess);
    },
    saveHomework(){
      var self = this;
      self.dataToSend.id = self.homeWorkData.id;
      self.dataToSend.title = self.homeWorkData.name;
      self.dataToSend.classroomId = self.selectedIndex.id;
      self.dataToSend.description =self.homeWorkData.description;
      self.dataToSend.dueDate =  moment(new Date(Date.parse(self.homeWorkData.date)).toISOString()).format('YYYY-MM-DD');
      self.dataToSend.homeworkBookTagId = parseInt(self.tags[self.tagDropdown].value);

      var onSuccess = response => {
        self.homeWorkData.id = response.data;
        self.calendarPopupActive = false;
        self.getEvents(self.pickerDate);
        self.$vs.notify({
          title: "Information",
          color: "success",
          text: "Homework Saved",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-save"
        });
      };

      self.$ajaxPost(self, "HomeworkBook/AddEdit", self.dataToSend , onSuccess);
      
    },
    deleteHomeWork(){
      var self = this;
      var onSuccess = response => {
        self.calendarPopupActive = false;
        self.getEvents(self.pickerDate);
        self.$vs.notify({
          title: "Information",
          color: "success",
          text: "Homework Deleted",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-save"
        });
      };
      self.$ajaxGet(self, `HomeworkBook/DeleteHomeworkBookItem/${self.homeWorkData.id}`  , onSuccess);
    },
    saveStreamEvent() {
      var self = this;
      
      self.$validator.validateAll().then(result => {
        if (result) {
          self.showLoadingOnElement("saveStreamButton", 0.45, "material");

          self.streamEventData.moduleId = self.topicDropdown ? parseInt(self.topicDropdown.value) : null;

          var onSuccess = response => {
            self.streamEventData.id = response.data.id;
            self.streamEventData.liveStreamName = response.data.liveStreamName;
            self.streamEventData.liveStreamUrl = response.data.liveStreamUrl;
            self.streamEventData.includeChat = response.data.includeChat;
            
            self.getEvents(self.pickerDate);

            self.$vs.notify({
              title: "Information",
              color: "success",
              text: "Event Saved",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-save"
            });
          };
          var onFinally = function (){
            self.$vs.loading.close(self.$refs.saveStreamButton.$el);
          };

          self.$ajaxPost(self, "LiveStreamTask/AddEditLiveStreamTask", self.streamEventData, onSuccess, onFinally);
        } else {
          self.$vs.notify({
            title: "Attention",
            color: "warning",
            text:  self.$validator.errors.items[0].msg,
            position: "top-right",
            iconPack: "feather",
            icon: "icon-info"
          });
        }
      });
    },
    editEvent(event) {
      var self = this;
      self.calendarPopupActive = true;
      if(!Array.isArray(event.classroomId) && event.homeworkBookTagId){
        self.homeWorkData.id = event.id;
        self.homeWorkData.name = event.title;
        self.homeWorkData.description = event.description;
        self.tagDropdown = event.homeworkBookTagId -1;
        self.homeWorkData.classrooms.forEach(element => {
          if(element.id == event.classroomId){
            element.selected = true;
          }
        });
        self.activeTab = 3;

      }
      else if (event.topicId && event.streamUrl) {
        self.streamEventData.id = event.taskId;
        self.streamEventData.name = event.title;
        self.streamEventData.description = event.description;

        var dateObject = new Date(Date.parse(event.date));
        var formattedDate = moment(dateObject.toISOString()).format("DD MMMM YYYY");

        self.streamEventData.date = formattedDate;
        self.streamEventData.startTime = event.startTime;
        self.streamEventData.endTime = event.endTime;
        self.streamEventData.liveStreamName = event.streamName;
        self.streamEventData.liveStreamUrl = event.streamUrl;
        self.streamEventData.includeChat = event.includeChat;

        self.streamEventData.classrooms.forEach(function(item){
          item.selected = event.classroomIds.filter(function(id) { return id == item.id}).length > 0;
        })

        self.streamSubjectDropdown = self.subjects.filter(function (item) { return item.value == event.subjectId; })[0];
        self.getTopics(self.streamSubjectDropdown.value, function () {
          self.topicDropdown = self.topics.filter(function (item) { return item.value == event.topicId; })[0];
        });
      }
      else if (event.topicId && event.googleMeetUrl) {
        self.activeTab = 2;
        self.videoChatEventData.id = event.taskId;
        self.videoChatEventData.name = event.title;
        self.videoChatEventData.description = event.description;

        var dateObject = new Date(Date.parse(event.date));
        var formattedDate = moment(dateObject.toISOString()).format("DD MMMM YYYY");

        self.videoChatEventData.date = formattedDate;
        self.videoChatEventData.startTime = event.startTime;
        self.videoChatEventData.endTime = event.endTime;
        self.videoChatEventData.googleMeetUrl = event.googleMeetUrl;

        self.videoChatEventData.classrooms.forEach(function(item){
          item.selected = event.classroomIds.filter(function(id) { return id == item.id}).length > 0;
        })

        self.videoChatSubjectDropdown = self.subjects.filter(function (item) { return item.value == event.subjectId; })[0];
        self.getTopics(self.videoChatSubjectDropdown.value, function () {
          self.topicDropdown = self.topics.filter(function (item) { return item.value == event.topicId; })[0];
        });
      }
      else {
        self.notifyEventData.notificationId = event.notificationId;

        self.activeTab = 1;
        
        self.notifyEventData.title = event.title;
        self.notifyEventData.message = event.notificationMessage;
        
        self.notifyEventData.fromDate = new Date(Date.parse(event.notificationStartDate));
        self.notifyEventData.toDate = new Date(Date.parse(event.notificationEndDate));

        var startHour = self.notifyEventData.fromDate.getHours();
        var startMins = self.notifyEventData.fromDate.getMinutes();

        if (startHour < 10) {
          startHour = "0" + startHour;
        }

        if (startMins < 10) {
          startMins = "0" + startMins;
        }
        var startTime = startHour + ":" + startMins;


        var endHour = self.notifyEventData.toDate.getHours();
        var endMins = self.notifyEventData.toDate.getMinutes();

        if (endHour < 10) {
          endHour = "0" + endHour;
        }

        if (endMins < 10) {
          endMins = "0" + endMins;
        }

        var endTime = endHour + ":" + endMins;

        setTimeout(function () {
          self.$refs.notifyStartTimePicker.setValue(startTime);
          self.$refs.notifyEndTimePicker.setValue(endTime);
          if (event.subjectId) {
            self.notifyType = 0;
            self.subjectDropdown = self.subjects.filter(function (item) { return item.value == event.subjectId; })[0];
          }
        }, 600);

        if (!event.subjectId) {
          self.notifyType = 1;
          self.notifyEventData.classrooms.forEach(function(item){
            item.selected = event.classroomIds.filter(function(id) { return id == item.id}).length > 0;
          });
        }
      }
    },
    deleteStreamEvent() {
      var self = this;
      self.showLoadingOnElement("deleteStreamButton", 0.45, "material");

      var onSuccess = response => {
        self.calendarPopupActive = false;
        self.getEvents(self.pickerDate);

        self.$vs.notify({
          title: "Information",
          color: "success",
          text: "Event Deleted",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-trash-2"
        });
      };
      var onFinally = function (){
        self.$vs.loading.close(self.$refs.deleteStreamButton.$el);
      };

      self.$ajaxDelete(self, "LiveStreamTask/RemoveLiveStreamTask/" + self.streamEventData.id, onSuccess, onFinally);
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    scrollToFooter() {
      var scrollOptions = {
        easing: "ease-in",
        offset: -480,
        force: true,
        cancelable: true,
        x: false,
        y: true
      };
      var cancelScroll = this.$scrollTo(
        document.getElementById("footerGlobal"),
        100,
        scrollOptions
      );
    },
    getCurrentUserId() {
      var self = this;
	  
      var userIdFromLocalStorage = localStorage.getItem("Current_User_Id");

      if (userIdFromLocalStorage != undefined && userIdFromLocalStorage != null && userIdFromLocalStorage != "") {
        self.currentUserId = JSON.parse(userIdFromLocalStorage);
        return;
      }

      var onSuccess = response => {
        localStorage.setItem("Current_User_Id", response.data);
        self.currentUserId = JSON.parse(localStorage.getItem('Current_User_Id'));
      };
      self.$ajaxGet(self, "user/GetUserId", onSuccess);
    },
    selectSubject() {
      if (this.streamSubjectDropdown.value) {
        this.getTopics(this.streamSubjectDropdown.value);
      }
      else if (this.videoChatSubjectDropdown.value) {
        this.getTopics(this.videoChatSubjectDropdown.value);
      }
    },
    onNameCopy() {
      this.$vs.notify({
        title: "Success",
        color: "success",
        text:  "Name copied successfully!",
        position: "top-center",
        iconPack: "feather",
        icon: "icon-clipboard"
      });
    },
    onLinkCopy() {
      this.$vs.notify({
        title: "Success",
        color: "success",
        text:  "Link copied successfully!",
        position: "top-center",
        iconPack: "feather",
        icon: "icon-clipboard"
      });
    },
    saveNotifyEvent() {
      var self = this;
      
      self.$validator.validateAll().then(result => {
        if (result) {
          self.showLoadingOnElement("saveNotifyButton", 0.45, "material");

          self.notifyEventData.courseId = self.subjectDropdown ? parseInt(self.subjectDropdown.value) : null;

          var startHour = self.notifyEventData.startTime.split(":")[0];
          var startMinutes = self.notifyEventData.startTime.split(":")[1];

          var endHour = self.notifyEventData.endTime.split(":")[0];
          var endMinutes = self.notifyEventData.endTime.split(":")[1];

          startHour = parseInt(startHour) + 2;
          endHour = parseInt(endHour) + 2;

          self.notifyEventData.fromDate.setHours(startHour);
          self.notifyEventData.fromDate.setMinutes(startMinutes);

          self.notifyEventData.toDate.setHours(endHour);
          self.notifyEventData.toDate.setMinutes(endMinutes);

          var onSuccess = response => {
            self.notifyEventData.notificationId = response.data.id;
            self.calendarPopupActive = false;
            self.getEvents(self.pickerDate);

            self.$vs.notify({
              title: "Information",
              color: "success",
              text: "Event Saved",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-save"
            });
          };
          var onFinally = function (){
            self.$vs.loading.close(self.$refs.saveNotifyButton.$el);
          };

          self.$ajaxPost(self, "Teacher/SaveNotification", self.notifyEventData, onSuccess, onFinally);
        } else {
          self.$vs.notify({
            title: "Attention",
            color: "warning",
            text:  self.$validator.errors.items[0].msg,
            position: "top-right",
            iconPack: "feather",
            icon: "icon-info"
          });
        }
      });
    },
    deleteNotifyEvent() {
      var self = this;
      self.showLoadingOnElement('deleteNotifyButton', 0.35, 'material');

      var onSuccess = function(response) {
        self.calendarPopupActive = false;
        self.getEvents(self.pickerDate);
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: "Notification(s) removed",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-x'
        });
        self.initValues();
      };

      var onFinally = function(response) {
        self.$vs.loading.close(self.$refs.deleteNotifyButton.$el);
      };

      self.$ajaxGet(self, "Teacher/RemoveNotification/" + self.notifyEventData.notificationId, onSuccess, onFinally);
    },
    saveVideoChatEvent() {
      var self = this;
      
      self.$validator.validateAll().then(result => {
        if (result) {
          self.showLoadingOnElement("saveVideoChatButton", 0.45, "material");

          self.videoChatEventData.moduleId = self.topicDropdown ? parseInt(self.topicDropdown.value) : null;

          var onSuccess = response => {
            self.videoChatEventData.id = response.data.id;
            self.calendarPopupActive = false;
            self.getEvents(self.pickerDate);

            self.$vs.notify({
              title: "Information",
              color: "success",
              text: "Event Saved",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-save"
            });
          };
          var onFinally = function (){
            self.$vs.loading.close(self.$refs.saveVideoChatButton.$el);
          };
          self.$ajaxPost(self, "VideoChatTask/AddEditVideoChatTask", self.videoChatEventData, onSuccess, onFinally);
        } else {
          self.$vs.notify({
            title: "Attention",
            color: "warning",
            text:  self.$validator.errors.items[0].msg,
            position: "top-right",
            iconPack: "feather",
            icon: "icon-info"
          });
        }
      });
    },
    deleteVideoChatEvent() {
      var self = this;
      self.showLoadingOnElement("deleteVideoChatButton", 0.45, "material");

      var onSuccess = response => {
        self.calendarPopupActive = false;
        self.getEvents(self.pickerDate);

        self.$vs.notify({
          title: "Information",
          color: "success",
          text: "Event Deleted",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-trash-2"
        });
      };
      var onFinally = function (){
        self.$vs.loading.close(self.$refs.deleteVideoChatButton.$el);
      };

      self.$ajaxDelete(self, "VideoChatTask/RemoveVideoChatTask/" + self.videoChatEventData.id, onSuccess, onFinally);
    },
    formatNotificationDate(date) {
      var self = this;
      if(date){
        var dateString = new Date(Date.parse(date));

        var hour = dateString.getHours();
        var minutes = dateString.getMinutes();

        var result = moment(dateString.toISOString()).format("DD MMMM YYYY HH:mm");
        return result;
      }
      
    },
    addDays(date, days) {
      var result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    }
  },
  mounted() {
    var self = this;
    self.getEvents(self.pickerDate);
    self.getClassrooms();
    self.getSubjects();
    self.getCurrentUserId();
    self.getPriority();
  }
};
</script>

<style lang="scss">
  @import "../assets/main-digi.scss";
  #calendar-popup{
    .clock-picker__dialog-body{
      z-index: 401 !important;
    }
    .clock-picker__dialog-drop{
      z-index: 400 !important;
    }
    
  }
  .priority{
    display: flex;

  }

  .label1{
    label{
      color: green;
    }
  }
  .label2{
    label{
      color: yellow;
    }
  }
  .label3{
    label{
      color: red;
    }
  }
</style>
